const BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
const PAYMENTS_URL = process.env.NEXT_PUBLIC_PAYMENTS_HOST;

export const endPointEnums = {
  SEND_OTP: 'sendOTP',
  VERIFY_OTP: 'verifyOTP',
  VERIFY_FIREBASE_TOKEN: 'verifyFirebaseToken',
  ADMIN_BYPASS: 'adminBypass',
  CHECK_ADMIN_BYPASS: 'checkAdminBypass',
  CREATE_PARCEL: 'createParcel',
  GET_PARCELS_LIST: 'getParcelsList',
  REGISTER_USER_DEVICE: 'registerUserDevice',
  GET_PARCEL_BY_ID: 'getParcelById',
  WALLET_BALANCE: 'walletBalance',
  GET_WALLET: 'getWallet',
  WALLET_CREATE_ORDER: 'walletCreateOrder',
  WALLET_PAYMENT_STATUS: 'walletPaymentStatus',
  WALLET_DEDUCT: 'walletDeduct',
  WALLET_BLOCK: 'walletBlock',
  WALLET_UNBLOCK: 'walletUnblock',
  WALLET_FINALIZE: 'walletFinalize',
  WALLET_TRANSACTIONS: 'walletTransactions',
  GET_USER_PROFILE: 'getUserProfile',
  UPDATE_USER_PROFILE: 'updateUserProfile',
  GET_ACTIVE_PRICING: 'getActivePricing',
  CALCULATE_PRICE: 'calculatePrice',
  // Pricing Engine V2
  CALCULATE_PRICE_V2: 'calculatePriceV2',
  SIMULATE_PRICE_V2: 'simulatePriceV2',
  // Pricing Engine V3 (Business/Contracts)
  CALCULATE_PRICE_V3: 'calculatePriceV3',
  GET_MY_CONTRACT: 'getMyContract',
  // Universal Pricing Router
  GET_MY_PRICING_INFO: 'getMyPricingInfo',
  CALCULATE_BUSINESS_PRICE: 'calculateBusinessPrice',
  // Bulk Pricing (for business users without contracts)
  CALCULATE_BULK_PRICE: 'calculateBulkPrice',
  GET_BULK_PRICING_SLABS: 'getBulkPricingSlabs',
  // UPI Intent payment endpoints
  UPI_CREATE_INTENT: 'upiCreateIntent',
  UPI_CONFIRM_PAYMENT: 'upiConfirmPayment',
  UPI_VERIFY: 'upiVerify',
  UPI_STATUS: 'upiStatus',

  // COD payment endpoint
  COD_PAYMENT: 'codPayment',

  // Multi-stage delivery leg endpoints (read-only for users)
  GET_LEGS_BY_PARCEL: 'getLegsByParcel',
  GET_CURRENT_LEG: 'getCurrentLeg',

  // Business user endpoints
  UPDATE_USER_TYPE: 'updateUserType',
  GET_SAVED_ADDRESSES: 'getSavedAddresses',
  CREATE_SAVED_ADDRESS: 'createSavedAddress',
  UPDATE_SAVED_ADDRESS: 'updateSavedAddress',
  DELETE_SAVED_ADDRESS: 'deleteSavedAddress',
  GET_DEFAULT_ADDRESS: 'getDefaultAddress',
  SET_DEFAULT_ADDRESS: 'setDefaultAddress',
  GET_BUSINESS_PROFILE: 'getBusinessProfile',
  UPSERT_BUSINESS_PROFILE: 'upsertBusinessProfile',
  GET_BUSINESS_METRICS: 'getBusinessMetrics',
  GET_BUSINESS_STATS: 'getBusinessStats',
  GET_CURRENT_MONTH_METRICS: 'getCurrentMonthMetrics',
  CALCULATE_MONTH_METRICS: 'calculateMonthMetrics',

  // Shipment templates
  GET_SHIPMENT_TEMPLATES: 'getShipmentTemplates',
  GET_SHIPMENT_TEMPLATE_BY_ID: 'getShipmentTemplateById',
  CREATE_SHIPMENT_TEMPLATE: 'createShipmentTemplate',
  UPDATE_SHIPMENT_TEMPLATE: 'updateShipmentTemplate',
  DELETE_SHIPMENT_TEMPLATE: 'deleteShipmentTemplate',
  USE_SHIPMENT_TEMPLATE: 'useShipmentTemplate',

  // B2B Subscription endpoints
  GET_B2B_PACKAGES: 'getB2BPackages',
  GET_MY_SUBSCRIPTION: 'getMySubscription',
  SUBSCRIBE_TO_PACKAGE: 'subscribeToPackage',

  // Bulk Orders (B2B)
  CREATE_BULK_ORDER: 'createBulkOrder',
  GET_BULK_ORDERS: 'getBulkOrders',
  GET_BULK_ORDER_BY_ID: 'getBulkOrderById',
  UPDATE_BULK_ORDER: 'updateBulkOrder',
  DELETE_BULK_ORDER: 'deleteBulkOrder',
  ADD_BULK_ORDER_ITEM: 'addBulkOrderItem',
  UPDATE_BULK_ORDER_ITEM: 'updateBulkOrderItem',
  DELETE_BULK_ORDER_ITEM: 'deleteBulkOrderItem',
  DUPLICATE_BULK_ORDER_ITEM: 'duplicateBulkOrderItem',
  CALCULATE_BULK_PRICING: 'calculateBulkPricing',
  SUBMIT_BULK_ORDER: 'submitBulkOrder',
  REVERT_BULK_ORDER_TO_DRAFT: 'revertBulkOrderToDraft',
  CONFIRM_BULK_ORDER: 'confirmBulkOrder',
  PAY_BULK_ORDER_WITH_WALLET: 'payBulkOrderWithWallet',
  CANCEL_BULK_ORDER: 'cancelBulkOrder',
};

export const configEnums = {
  GET_APP_CONFIG: 'getAppConfig',
};

export const endpoints = {
  getAppConfig: {
    url: BASE_URL + '/api/config/user-app',
    method: 'get',
  },
  sendOTP: {
    url: BASE_URL + '/api/otp/send-otp',
    method: 'post',
  },
  verifyOTP: {
    url: BASE_URL + '/api/otp/validate-otp',
    method: 'post',
  },
  verifyFirebaseToken: {
    url: BASE_URL + '/api/auth/verify-firebase-token',
    method: 'post',
  },
  adminBypass: {
    url: BASE_URL + '/api/auth/admin-bypass',
    method: 'post',
  },
  checkAdminBypass: {
    url: BASE_URL + '/api/auth/check-admin-bypass',
    method: 'post',
  },
  getUserProfile: {
    url: BASE_URL + '/api/user/profile',
    method: 'get',
  },
  updateUserProfile: {
    url: BASE_URL + '/api/user/profile',
    method: 'put',
  },
  createParcel: {
    url: BASE_URL + '/api/parcel/create',
    method: 'post',
  },
  getParcelsList: {
    url: BASE_URL + '/api/parcel/parcels-list',
    method: 'get',
  },
  registerUserDevice: {
    url: BASE_URL + '/api/device/register-user-device-token',
    method: 'post',
  },
  getParcelById: {
    url: BASE_URL + '/api/parcel',
    method: 'get',
  },
  walletBalance: {
    url: PAYMENTS_URL + '/wallet/balance',
    method: 'get',
  },
  getWallet: {
    url: PAYMENTS_URL + '/wallet',
    method: 'get',
  },
  walletUnblock: {
    url: PAYMENTS_URL + '/wallet/unblock',
    method: 'post',
  },
  walletCreateOrder: {
    url: PAYMENTS_URL + '/payments/create-order',
    method: 'post',
  },
  walletPaymentStatus: {
    url: PAYMENTS_URL + '/payments/status',
    method: 'get',
  },

  // UPI Intent endpoints
  upiCreateIntent: {
    url: PAYMENTS_URL + '/upi/create-intent',
    method: 'post',
  },
  upiConfirmPayment: {
    url: PAYMENTS_URL + '/upi/confirm-payment',
    method: 'post',
  },
  upiVerify: {
    url: PAYMENTS_URL + '/upi/verify',
    method: 'post',
  },
  upiStatus: {
    url: PAYMENTS_URL + '/upi/status',
    method: 'get',
  },
  codPayment: {
    url: PAYMENTS_URL + '/payments/cod-payment',
    method: 'post',
  },
  walletDeduct: {
    url: PAYMENTS_URL + '/wallet/deduct',
    method: 'post',
  },
  walletBlock: {
    url: PAYMENTS_URL + '/wallet/block',
    method: 'post',
  },
  walletFinalize: {
    url: PAYMENTS_URL + '/wallet/finalize',
    method: 'post',
  },
  walletTransactions: {
    url: PAYMENTS_URL + '/wallet/transactions',
    method: 'get',
  },
  getActivePricing: {
    url: BASE_URL + '/api/pricing/active',
    method: 'get',
  },
  calculatePrice: {
    url: BASE_URL + '/api/pricing/router/calculate',
    method: 'post',
  },
  // Get my pricing info (which type applies to me)
  getMyPricingInfo: {
    url: BASE_URL + '/api/pricing/router/my-pricing',
    method: 'get',
  },
  // Pricing Engine V2 endpoints
  calculatePriceV2: {
    url: BASE_URL + '/api/pricing/v2/calculate',
    method: 'post',
  },
  simulatePriceV2: {
    url: BASE_URL + '/api/pricing/v2/simulate',
    method: 'get',
  },
  // Business Pricing (Contract-based)
  calculateBusinessPrice: {
    url: BASE_URL + '/api/business-pricing/calculate',
    method: 'post',
  },
  getMyContract: {
    url: BASE_URL + '/api/business-pricing/my-contract',
    method: 'get',
  },
  // Bulk Pricing (Items + Distance based)
  calculateBulkPrice: {
    url: BASE_URL + '/api/bulk-pricing/calculate',
    method: 'post',
  },
  getBulkPricingSlabs: {
    url: BASE_URL + '/api/bulk-pricing/slabs',
    method: 'get',
  },
  // Multi-stage delivery leg endpoints (read-only for users to track their parcel journey)
  getLegsByParcel: {
    url: (parcelId) => BASE_URL + `/api/parcel/${parcelId}/legs`,
    method: 'get',
  },
  getCurrentLeg: {
    url: (parcelId) => BASE_URL + `/api/leg/parcel/${parcelId}/current`,
    method: 'get',
  },

  // Business user endpoints
  updateUserType: {
    url: BASE_URL + '/api/user/user-type',
    method: 'put',
  },
  getSavedAddresses: {
    url: BASE_URL + '/api/user/addresses',
    method: 'get',
  },
  createSavedAddress: {
    url: BASE_URL + '/api/user/addresses',
    method: 'post',
  },
  updateSavedAddress: {
    url: (addressId) => BASE_URL + `/api/user/addresses/${addressId}`,
    method: 'put',
  },
  deleteSavedAddress: {
    url: (addressId) => BASE_URL + `/api/user/addresses/${addressId}`,
    method: 'delete',
  },
  getDefaultAddress: {
    url: (addressType) => BASE_URL + `/api/user/addresses/default/${addressType}`,
    method: 'get',
  },
  setDefaultAddress: {
    url: (addressId) => BASE_URL + `/api/user/addresses/${addressId}/set-default`,
    method: 'put',
  },
  getBusinessProfile: {
    url: BASE_URL + '/api/user/business/profile',
    method: 'get',
  },
  upsertBusinessProfile: {
    url: BASE_URL + '/api/user/business/profile',
    method: 'post',
  },
  getBusinessMetrics: {
    url: (year, month) => BASE_URL + `/api/user/business/metrics/${year}/${month}`,
    method: 'get',
  },
  getBusinessStats: {
    url: BASE_URL + '/api/user/business/stats',
    method: 'get',
  },
  getCurrentMonthMetrics: {
    url: BASE_URL + `/api/user/business/metrics/current`,
    method: 'get',
  },
  calculateMonthMetrics: {
    url: (year, month) => BASE_URL + `/api/user/business/calculate-metrics/${year}/${month}`,
    method: 'post',
  },

  // Shipment templates endpoints
  getShipmentTemplates: {
    url: BASE_URL + '/api/user/templates',
    method: 'get',
  },
  getShipmentTemplateById: {
    url: (templateId) => BASE_URL + `/api/user/templates/${templateId}`,
    method: 'get',
  },
  createShipmentTemplate: {
    url: BASE_URL + '/api/user/templates',
    method: 'post',
  },
  updateShipmentTemplate: {
    url: (templateId) => BASE_URL + `/api/user/templates/${templateId}`,
    method: 'put',
  },
  deleteShipmentTemplate: {
    url: (templateId) => BASE_URL + `/api/user/templates/${templateId}`,
    method: 'delete',
  },
  useShipmentTemplate: {
    url: (templateId) => BASE_URL + `/api/user/templates/${templateId}/use`,
    method: 'post',
  },

  // B2B Subscription endpoints
  getB2BPackages: {
    url: BASE_URL + '/api/pricing/b2b-packages',
    method: 'get',
  },
  getMySubscription: {
    url: BASE_URL + '/api/pricing/my-subscription',
    method: 'get',
  },
  subscribeToPackage: {
    url: BASE_URL + '/api/pricing/subscribe',
    method: 'post',
  },

  // ============================================================================
  // BULK ORDERS (B2B)
  // ============================================================================

  // Bulk order CRUD
  createBulkOrder: {
    url: BASE_URL + '/api/bulk-orders',
    method: 'post',
  },
  getBulkOrders: {
    url: BASE_URL + '/api/bulk-orders',
    method: 'get',
  },
  getBulkOrderById: {
    url: (bulkOrderId) => BASE_URL + `/api/bulk-orders/${bulkOrderId}`,
    method: 'get',
  },
  updateBulkOrder: {
    url: (bulkOrderId) => BASE_URL + `/api/bulk-orders/${bulkOrderId}`,
    method: 'put',
  },
  deleteBulkOrder: {
    url: (bulkOrderId) => BASE_URL + `/api/bulk-orders/${bulkOrderId}`,
    method: 'delete',
  },

  // Bulk order items
  addBulkOrderItem: {
    url: (bulkOrderId) => BASE_URL + `/api/bulk-orders/${bulkOrderId}/items`,
    method: 'post',
  },
  updateBulkOrderItem: {
    url: (bulkOrderId, itemId) => BASE_URL + `/api/bulk-orders/${bulkOrderId}/items/${itemId}`,
    method: 'put',
  },
  deleteBulkOrderItem: {
    url: (bulkOrderId, itemId) => BASE_URL + `/api/bulk-orders/${bulkOrderId}/items/${itemId}`,
    method: 'delete',
  },
  duplicateBulkOrderItem: {
    url: (bulkOrderId, itemId) =>
      BASE_URL + `/api/bulk-orders/${bulkOrderId}/items/${itemId}/duplicate`,
    method: 'post',
  },

  // Bulk order workflow
  calculateBulkPricing: {
    url: (bulkOrderId) => BASE_URL + `/api/bulk-orders/${bulkOrderId}/calculate-pricing`,
    method: 'post',
  },
  submitBulkOrder: {
    url: (bulkOrderId) => BASE_URL + `/api/bulk-orders/${bulkOrderId}/submit`,
    method: 'post',
  },
  revertBulkOrderToDraft: {
    url: (bulkOrderId) => BASE_URL + `/api/bulk-orders/${bulkOrderId}/revert-to-draft`,
    method: 'post',
  },
  confirmBulkOrder: {
    url: (bulkOrderId) => BASE_URL + `/api/bulk-orders/${bulkOrderId}/confirm`,
    method: 'post',
  },
  payBulkOrderWithWallet: {
    url: (bulkOrderId) => BASE_URL + `/api/bulk-orders/${bulkOrderId}/pay-with-wallet`,
    method: 'post',
  },
  cancelBulkOrder: {
    url: (bulkOrderId) => BASE_URL + `/api/bulk-orders/${bulkOrderId}/cancel`,
    method: 'post',
  },
};
